import { mixpanel } from 'js/analytics/adapters'

export default () => {
  mixpanel.reset()
}
